module.exports = __webpack_public_path__ + "static/media/aboutus-bg3.78346258.jpg";